import 'react-toastify/dist/ReactToastify.css';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/pt-br';
import { ErrorBoundary } from 'react-error-boundary';
import { QueryClientProvider } from '@tanstack/react-query';
import { Routes } from './routes';
import theme from './styles/theme';
import { getCurrentTimezone } from './utils/dateHelpers';
import { PageErrorBoundary } from './components/PageErrorBoundary';
import { queryClient } from './services/queries';

dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.tz.setDefault(getCurrentTimezone());
dayjs.locale('pt-br');
dayjs().format();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <ErrorBoundary fallback={<PageErrorBoundary />}>
          <CssBaseline />
          <Routes />
          <ToastContainer />
        </ErrorBoundary>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
